import Typography from '@mui/material/Typography/Typography';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { AuthenticationSuccess } from 'src/routes/public/Authentication/AuthenticationSuccess';

const SetNewPasswordSuccess = () => (
    <>
        <title>Victron Professional - Password Update Success</title>
        <AuthenticationSuccess
            title={
                <FormattedMessage
                    id="auth.setNewPasswordSuccess.title"
                    defaultMessage="Password updated successfully"
                    description="Success title after password update. Used in: /auth/set-new-password/success"
                />
            }
            message={
                <>
                    <Typography fontFamily="Roboto" fontWeight={400} fontSize={14} mt={1}>
                        <FormattedMessage
                            id="auth.setNewPasswordSuccess.message"
                            defaultMessage="Your {professionalBrand} account password has been successfully updated.{lineBreaks}You may now continue with the {oneIdBrand} account migration process."
                            description="Success message after password update with migration info. Used in: /auth/set-new-password/success"
                            values={{
                                professionalBrand: 'Professional',
                                oneIdBrand: (
                                    <Typography component="b" fontFamily="inherit">
                                        Victron OneID
                                    </Typography>
                                ),
                                lineBreaks: (
                                    <>
                                        <br />
                                        <br />
                                    </>
                                ),
                            }}
                        />
                    </Typography>
                </>
            }
            primaryButtonProps={{
                children: (
                    <FormattedMessage
                        id="common.continue"
                        defaultMessage="Continue"
                        description="Text for continue button"
                    />
                ),
                component: Link,
                to: { pathname: '../login', search: window.location.search },
            }}
            stateVariable="new-password-allow"
        />
    </>
);

export { SetNewPasswordSuccess };
